import './wdyr';
import bootstrap from './bootstrap';

/*
  This is a custom event that is used to bootstrap the React app.
  It is triggered by the Iterable AngularJS app after it has initialized.
*/
window.addEventListener('iterable:start-react', bootstrap);

if (window.__includeAngularJs__) {
  /*
    When loading an AngularJS page, signal to AngularJS that React has been loaded
    so that AngularJS can initialize itself, and then initialize the React app.

    This is necessary because React initialization is now asynchronous, so AngularJS
    needs to wait for React to be loaded before it can initialize itself.
  */
  window.dispatchEvent(new CustomEvent('iterable:react-loaded'));

  // Remove this once we have released the event-based initialization changes to frontend and backend
  window.bootstrapReact = bootstrap;
} else {
  bootstrap(document.getElementById('react-root'));
}

export default bootstrap;
